/* @flow @format */
import { type ContextRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import React from 'react';

import { ButtonIcon, Footer, Page, PageContainer, Panel } from '@sonyged/ext-proc';
import Lock from '!!svg-react-loader!../../../assets/images/pages/top/lock.svg';

import type { Contest } from '../../redux/reducer/entities';
import type { ContestType, StoreState } from '../../redux/types';
import { makeT, themeOf } from './utils';
import { selectProgress } from '../../redux/selector';
import AppContext from '../../AppContext';
import LoadingButton from '../../components/LoadingButton';
import TitleModal from './TitleModal';

type OwnProps = {|
  ...ContextRouter,
  contest: Contest,
  contestType: ContestType,
  course: any,
|};

type Props = {
  ...OwnProps,
  progress: number,
};

type State = {
  selectedMissionId: number,
  titleModal: boolean,
};

const dict = {
  _: {
    missionLabel: 'こんかいの ミッション',
  },
  sushi: {
    missionLabel: '今回のミッション',
  },
  'ice-a': {
    missionLabel: '今回のミッション',
  },
  'sushi-a': {
    missionLabel: '今回のミッション',
  },
  'pizza-a': {
    missionLabel: '今回のミッション',
  },
};
const t = makeT(dict);

class CoursePage extends React.Component<Props, State> {
  static contextType = AppContext;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedMissionId: this._getIndexFromQuery(props),
      titleModal: false,
    };
  }

  componentDidMount() {
    this.context.soundController.bgmPlay('proc_chat_top01_home_re2', true);
  }

  render() {
    const {
      course: {
        courseContents: [{ bookInfo }],
      },
      contestType,
    } = this.props;

    if (this.state.titleModal) {
      return (
        <div id={'course-index-root-page'} className={themeOf(contestType)}>
          <TitleModal
            title={'ミッション'}
            subTitle={this.renderMissionTitle()}
            rootNodeId={'course-index-root-page'}
            onNext={this._onTitleNext.bind(this)}
          />
        </div>
      );
    }

    return (
      <div
        id={'course-index-root-page'}
        className={`proc-${contestType}-courses-index-page course-top-page-template tertiary100-bg-color ${themeOf(
          contestType
        )}`}
      >
        <Page.normal menu={false}>
          <PageContainer.normal>
            <Panel.vertical fullHeight={true}>
              <div className="course-top-page-content">
                <div className={'title-container'}>
                  <div className={'sub-title proc-medium-font secondary100-color'}>
                    {t(contestType, 'missionLabel')}
                  </div>
                  <div className={'title proc-huge-font gray100-color'}>{bookInfo.title}</div>
                </div>
                <div className={'secondary20-border-color proc-border'} />
                <div className={'missions-container secondary20-border-color'}>
                  {bookInfo.quizTitles.map((_title, index) => {
                    return this.renderMissionId(index + 1);
                  })}
                </div>
                <div className={'mission-desc-container proc-medium-font secondary20-bg-color gray100-color'}>
                  {this.renderMissionTitle()}
                </div>
                <img className={'image'} src={`../../images/pages/${contestType}/img_${contestType}_course@2x.png`} />
              </div>
              <Footer.nav
                className={'inner'}
                navItem={
                  <Link to={`/${contestType}`}>
                    <LoadingButton.normal className={'proc-button proc-button--normal'}>
                      <ButtonIcon.back />
                    </LoadingButton.normal>
                  </Link>
                }
              >
                <LoadingButton.attention className="next" onClick={this._onStartClick.bind(this)}>
                  はじめる
                </LoadingButton.attention>
              </Footer.nav>
            </Panel.vertical>
          </PageContainer.normal>
        </Page.normal>
      </div>
    );
  }

  renderMissionId(id: number) {
    const locked = id - 1 > this.props.progress;
    const selected = !locked && id === this.state.selectedMissionId;

    let classes = ['mission-index', 'proc-hover', 'proc-large-font'];
    if (locked) classes.push('locked', 'secondary60-fill-color');
    else classes.push('circle');
    if (selected) {
      classes.push(
        'active',
        'white-color',
        'secondary100-bg-color',
        'secondary100-border-color',
        'secondary20-after-border-bottom-color'
      );
    } else {
      classes.push('secondary100-color', 'secondary30-border-color');
    }

    let onClick = () => this._onMissionClick(id);
    if (selected || locked) {
      onClick = null;
    }

    return (
      <div key={id} className={classes.join(' ')} onClick={onClick}>
        {locked ? <Lock /> : id}
      </div>
    );
  }

  renderMissionTitle() {
    const {
      course: {
        courseContents: [{ bookInfo }],
      },
    } = this.props;
    return bookInfo.quizTitles[this.state.selectedMissionId - 1];
  }

  _onMissionClick(id: number) {
    this.setState({ selectedMissionId: id });
    this.props.history.replace(`#${id}`);
  }

  _getIndexFromQuery(props: Props) {
    const {
      course: {
        courseContents: [{ bookInfo }],
      },
    } = this.props;
    const paramId = props.location.hash;
    let id = paramId ? parseInt(paramId.substr(1)) : 1;
    const locked = id - 1 > this.props.progress;
    if (locked || id > bookInfo.quizTitles.length || id <= 0) {
      id = 1;
    }
    return id;
  }

  _onStartClick() {
    this.setState({ titleModal: true });
  }

  _onTitleNext() {
    const { course, contestType } = this.props;
    const nextUrl = course.isDefault
      ? `/${contestType}/courses/missions/${this.state.selectedMissionId}`
      : `/${contestType}/courses/${course.uid}/missions/${this.state.selectedMissionId}`;
    this.props.history.push(nextUrl);
  }
}

const mapState = (state: StoreState, { contest, course }: OwnProps) => {
  const progress = selectProgress(state, contest.uid, course.uid);
  return { progress };
};

export default connect<Props, OwnProps, _, _, _, _>(mapState)(CoursePage);
